import React from "react";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

type PostBannedProps = {
  bannedUntil: string;
};

export default function PostBanned(props: PostBannedProps) {
  const { closeModal } = useModal();

  return (
    <div className="text-center">
      <ModalTitle>Comment failed</ModalTitle>
      <Module>
        <p>
          Sorry, you have been temporarily banned from posting on this website.
          You can post again {props.bannedUntil}.
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faCheckCircle}
            onClick={closeModal}
            type="positive"
            rightAlign
          >
            Ok
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
